import "@/App.css";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import TrustBar from "@/components/TrustBar";
import FinancialMoat from "@/components/FinancialMoat";
import HowItWorks from "@/components/HowItWorks";
import FeaturesGrid from "@/components/FeaturesGrid";
import WhoItsFor from "@/components/WhoItsFor";
import ComparisonTable from "@/components/ComparisonTable";
import Testimonial from "@/components/Testimonial";
import Pricing from "@/components/Pricing";
import ROICalculator from "@/components/ROICalculator";
import DemoForm from "@/components/DemoForm";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="min-h-screen bg-vf-salt font-body text-vf-charcoal">
      <Navigation />
      <main>
        <HeroSection />
        <TrustBar />
        <FinancialMoat />
        <HowItWorks />
        <FeaturesGrid />
        <WhoItsFor />
        <ComparisonTable />
        <Testimonial />
        <Pricing />
        <ROICalculator />
        <DemoForm />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
